/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'@ba/ba-graphics/dist/icons-js/delete_32',
	'@ba/ba-graphics/dist/icons-js/object-group_16',
	'@ba/ba-graphics/dist/icons-js/object-ungroup_16',
	'@ba/ba-graphics/dist/icons-js/copy_32',
	'@ba/ba-graphics/dist/icons-js/bring-to-front_16',
	'@ba/ba-graphics/dist/icons-js/send-to-back_16',
	'@ba/ba-graphics/dist/icons-js/align--horizontal-center_32',
	'@ba/ba-graphics/dist/icons-js/align--horizontal-left_32',
	'@ba/ba-graphics/dist/icons-js/align--horizontal-right_32',
	'@ba/ba-graphics/dist/icons-js/align--vertical-top_32',
	'@ba/ba-graphics/dist/icons-js/align--vertical-center_32',
	'@ba/ba-graphics/dist/icons-js/align--vertical-bottom_32',
	'@ba/ba-graphics/dist/icons-js/align-top-center_32',
	'@ba/ba-graphics/dist/icons-js/align-middle-center_32',
	'@ba/ba-graphics/dist/icons-js/align-bottom-center_32',
	'@ba/ba-graphics/dist/icons-js/distribute--vertical-center_32',
	'@ba/ba-graphics/dist/icons-js/distribute--horizontal-center_32',
	'@ba/ba-graphics/dist/icons-js/text--indent--more_32',
	'@ba/ba-graphics/dist/icons-js/text--indent--less_32',
	'@ba/ba-graphics/dist/icons-js/close_32',
	'@ba/ba-graphics/dist/icons-js/pin_32',
	'@ba/ba-graphics/dist/icons-js/text--creation_32',
	'@ba/ba-graphics/dist/icons-js/explore_16',
	'@ba/ba-graphics/dist/icons-js/unlink_32',
	'@ba/ba-graphics/dist/icons-js/link_32',
	'@ba/ba-graphics/dist/icons-js/draw-link_16',
	'@ba/ba-graphics/dist/icons-js/toolbar-attach_32',
	'@ba/ba-graphics/dist/icons-js/toolbar-detatch_16',
	'@ba/ba-graphics/dist/icons-js/reset_32',
	'@ba/ba-graphics/dist/icons-js/edit_32',
	'@ba/ba-graphics/dist/icons-js/minimize_32',
	'@ba/ba-graphics/dist/icons-js/maximize_32',
	'@ba/ba-graphics/dist/icons-js/image_32',
	'@ba/ba-graphics/dist/icons-js/video-file_32',
	'@ba/ba-graphics/dist/icons-js/webpage_32',
	'@ba/ba-graphics/dist/icons-js/notebook_32',
	'@ba/ba-graphics/dist/icons-js/filter_24',
	'@ba/ba-graphics/dist/icons-js/template_32',
	'@ba/ba-graphics/dist/icons-js/list--bulleted_32',
	'@ba/ba-graphics/dist/icons-js/list--numbered_32',
	'@ba/ba-graphics/dist/icons-js/table_24',
	'@ba/ba-graphics/dist/icons-js/settings--adjust_32',
	'@ba/ba-graphics/dist/icons-js/connect_32',
	'@ba/ba-graphics/dist/icons-js/bullhorn_32',
	'@ba/ba-graphics/dist/icons-js/API--1_32',
	'@ba/ba-graphics/dist/icons-js/archive_32',
	'@ba/ba-graphics/dist/icons-js/microphone_32',
	'@ba/ba-graphics/dist/icons-js/attachment_32',
	'@ba/ba-graphics/dist/icons-js/volume--down--filled_32',
	'@ba/ba-graphics/dist/icons-js/bee_32',
	'@ba/ba-graphics/dist/icons-js/blog_32',
	'@ba/ba-graphics/dist/icons-js/bookmark_32',
	'@ba/ba-graphics/dist/icons-js/calendar_32',
	'@ba/ba-graphics/dist/icons-js/camera_32',
	'@ba/ba-graphics/dist/icons-js/capability_16',
	'@ba/ba-graphics/dist/icons-js/catalog_32',
	'@ba/ba-graphics/dist/icons-js/chat-message_16',
	'@ba/ba-graphics/dist/icons-js/checkout_16',
	'@ba/ba-graphics/dist/icons-js/client_16',
	'@ba/ba-graphics/dist/icons-js/time_32',
	'@ba/ba-graphics/dist/icons-js/cloud_32',
	'@ba/ba-graphics/dist/icons-js/code_32',
	'@ba/ba-graphics/dist/icons-js/data--check_32',
	'@ba/ba-graphics/dist/icons-js/folder_32',
	'@ba/ba-graphics/dist/icons-js/forum_32',
	'@ba/ba-graphics/dist/icons-js/glasses_16',
	'@ba/ba-graphics/dist/icons-js/events_32',
	'@ba/ba-graphics/dist/icons-js/hat_16',
	'@ba/ba-graphics/dist/icons-js/headphones_32',
	'@ba/ba-graphics/dist/icons-js/hills_24',
	'@ba/ba-graphics/dist/icons-js/home_32',
	'@ba/ba-graphics/dist/icons-js/idea_32',
	'@ba/ba-graphics/dist/icons-js/inventory_24',
	'@ba/ba-graphics/dist/icons-js/favorite_32',
	'@ba/ba-graphics/dist/icons-js/location_32',
	'@ba/ba-graphics/dist/icons-js/settings_16',
	'@ba/ba-graphics/dist/icons-js/markup-pen_16',
	'@ba/ba-graphics/dist/icons-js/mobile_32',
	'@ba/ba-graphics/dist/icons-js/music_32',
	'@ba/ba-graphics/dist/icons-js/notification_32',
	'@ba/ba-graphics/dist/icons-js/paint_24',
	'@ba/ba-graphics/dist/icons-js/purchase_32',
	'@ba/ba-graphics/dist/icons-js/password_32',
	'@ba/ba-graphics/dist/icons-js/people_16',
	'@ba/ba-graphics/dist/icons-js/person_32',
	'@ba/ba-graphics/dist/icons-js/phone_32',
	'@ba/ba-graphics/dist/icons-js/printer_32',
	'@ba/ba-graphics/dist/icons-js/recording_32',
	'@ba/ba-graphics/dist/icons-js/repository_16',
	'@ba/ba-graphics/dist/icons-js/identification_32',
	'@ba/ba-graphics/dist/icons-js/search_16',
	'@ba/ba-graphics/dist/icons-js/speaker_16',
	'@ba/ba-graphics/dist/icons-js/star--filled_16',
	'@ba/ba-graphics/dist/icons-js/tag_32',
	'@ba/ba-graphics/dist/icons-js/thumbs-up_32',
	'@ba/ba-graphics/dist/icons-js/thumbs-down_32',
	'@ba/ba-graphics/dist/icons-js/tools_32',
	'@ba/ba-graphics/dist/icons-js/traffic_16',
	'@ba/ba-graphics/dist/icons-js/logo--twitter_32',
	'@ba/ba-graphics/dist/icons-js/help_16',
	'@ba/ba-graphics/dist/icons-js/user_16',
	'@ba/ba-graphics/dist/icons-js/chart--venn-diagram_32',
	'@ba/ba-graphics/dist/icons-js/video_32',
	'@ba/ba-graphics/dist/icons-js/view_16',
	'@ba/ba-graphics/dist/icons-js/warning_16',
	'@ba/ba-graphics/dist/icons-js/watch_32',
	'@ba/ba-graphics/dist/icons-js/watson_32',
	'@ba/ba-graphics/dist/icons-js/wikis_32',
	'@ba/ba-graphics/dist/icons-js/workspace_32',
	'@ba/ba-graphics/dist/icons-js/globe_32',
	'@ba/ba-graphics/dist/icons-js/move_32',
	'@ba/ba-graphics/dist/icons-js/template_32',
	'@ba/ba-graphics/dist/icons-js/arrow--left_16',
	'@ba/ba-graphics/dist/icons-js/tab-control_32',
	'@ba/ba-graphics/dist/icons-js/distribute--horizontal-center_32',
	'@ba/ba-graphics/dist/icons-js/distribute--vertical-center_32',
	'@ba/ba-graphics/dist/icons-js/zoom--in_32',
	'../../../lib/@waca/carbon-icons'
], function(
	deleteIcon,
	groupIcon,
	ungroupIcon,
	copyIcon,
	toFrontIcon,
	toBackIcon,
	alignHorizontallyIcon,
	alignLeftIcon,
	alignRightIcon,
	alignTopIcon,
	alignVerticallyIcon,
	alignBottomIcon,
	alignTopCenterIcon,
	alignMiddleCenterIcon,
	alignBottomCenterIcon,
	distributeVerticalIcon,
	distributeHorizontalIcon,
	textIndentMoreIcon,
	textIndentLessIcon,
	closeIcon,
	pinIcon,
	textCreationIcon,
	exploreIcon,
	unlinkIcon,
	linkIcon,
	newLinkIcon,
	dockIcon,
	undockIcon,
	restoreIcon,
	editIcon,
	minimizeIcon,
	maximizeIcon,
	imageIcon,
	videoFileIcon,
	webpageIcon,
	notebookIcon,
	filterIcon,
	templateIcon,
	bulletListIcon,
	numberedListIcon,
	tableIcon,
	configureIcon,
	connectIcon,
	bullhornIcon,
	apiIcon,
	archiveIcon,
	microphoneIcon,
	attachmentIcon,
	audioIcon,
	beeIcon,
	blogIcon,
	bookmarkIcon,
	calendarIcon,
	cameraIcon,
	capabilityIcon,
	catalogIcon,
	messageIcon,
	checkoutIcon,
	clientIcon,
	timeIcon,
	cloudIcon,
	codeIcon,
	dataCheckIcon,
	folderIcon,
	forumIcon,
	glassesIcon,
	eventsIcon,
	hatIcon,
	headphonesIcon,
	hillsIcon,
	homeIcon,
	ideaIcon,
	inventoryIcon,
	favoriteIcon,
	locationIcon,
	settingsIcon,
	markupPenIcon,
	mobileIcon,
	musicIcon,
	notificationsIcon,
	paintIcon,
	purchaseIcon,
	passwordIcon,
	peopleIcon,
	personIcon,
	phoneIcon,
	printerIcon,
	recordingIcon,
	repositoryIcon,
	identificationIcon,
	searchIcon,
	speakerIcon,
	starIcon,
	tagIcon,
	thumbsUpIcon,
	thumbsDownIcon,
	toolsIcon,
	trafficIcon,
	twitterIcon,
	helpIcon,
	userIcon,
	vennDiagramIcon,
	videoIcon,
	viewIcon,
	warningIcon,
	watchIcon,
	watsonIcon,
	wikiIcon,
	workspaceIcon,
	globeIcon,
	moveIcon,
	dashboardTemplates,
	arrowLeftIcon,
	tabControl,
	distributeHorizontalCenter,
	distributeVerticalCenter,
	zoomIn,
	CarbonIcons
) {

	const { Reset16 } = CarbonIcons;

	return class CoreIconsProvider {
		constructor({ features }) {
			this._icons = features.Icons;
			this._dashboard = features.API;
		}

		initialize() {
			//TODO: ensure providers are created - keeping the initialize does that - but this seems odd as there is
			//no async init processing
			//
			//there are problems if we don't create this feature sooner ...
			//initially had moved the initialize logic to ctor, but then there are issues where code tries to access icons,
			//but the icon providers haven't registered yet, so moved it back to initialize

			const featureChecker = this._dashboard.getGlassCoreSvc('.FeatureChecker');
			const coreIconsList = CoreIconsProvider.getIconsList(featureChecker);
			this._icons.registerIcons(coreIconsList);
		}


		// !!!WARNING!!! !!!WARNING!!! !!!WARNING!!!
		// DO NOT UPDATE IDs
		// If you need to update an ID, please write an upgrade script to correct out-of-date dashboards.
		// Some of these IDs are persisted to the dashboard spec.
		static getIconsList (featureChecker) {
			const isPropertiesV2Enabled = featureChecker && featureChecker.checkValue('dashboard', 'PropertiesV2', 'enabled');

			return [
				{
					id: 'dashboard-delete',
					icon: deleteIcon
				},
				{
					id: 'dashboard-group',
					icon: groupIcon
				},
				{
					id: 'dashboard-ungroup',
					icon: ungroupIcon
				},
				{
					id: 'dashboard-duplicate',
					icon: copyIcon
				},
				{
					id: 'bring-to-front',
					icon: toFrontIcon
				},
				{
					id: 'send-to-back',
					icon: toBackIcon
				},
				{
					id: 'align-horizontally',
					icon: alignHorizontallyIcon
				},
				{
					id: 'align-left',
					icon: alignLeftIcon
				},
				{
					id: 'align-right',
					icon: alignRightIcon
				},
				{
					id: 'align-top',
					icon: alignTopIcon
				},
				{
					id: 'align-vertically',
					icon: alignVerticallyIcon
				},
				{
					id: 'align-bottom',
					icon: alignBottomIcon
				},
				{
					id: 'align-top-center',
					icon: alignTopCenterIcon
				},
				{
					id: 'align-middle-center',
					icon: alignMiddleCenterIcon
				},
				{
					id: 'align-bottom-center',
					icon: alignBottomCenterIcon
				},
				{
					id: 'distribute-vertical',
					icon: distributeVerticalIcon
				},
				{
					id: 'distribute-horizontal',
					icon: distributeHorizontalIcon
				},
				{
					id: 'text-indent-more',
					icon: textIndentMoreIcon
				},
				{
					id: 'text-indent-less',
					icon: textIndentLessIcon
				},
				{
					id: 'dismiss',
					icon: closeIcon
				},
				{
					id: 'pin',
					icon: pinIcon
				},
				{
					id: 'text-creation',
					icon: textCreationIcon
				},
				{
					id: 'explore',
					icon: exploreIcon
				},
				{
					id: 'unlink',
					icon: unlinkIcon
				},
				{
					id: 'link',
					icon: linkIcon
				},
				{
					id: 'new-link',
					icon: newLinkIcon
				},
				{
					id: 'dock-icon',
					icon: dockIcon
				},
				{
					id: 'undock-icon',
					icon: undockIcon
				},
				{
					id: 'restore',
					icon: isPropertiesV2Enabled ? {
						default: {
							...Reset16,
							id: 'Reset16'
						}
					} : restoreIcon
				},
				{
					id: 'edit',
					icon: editIcon
				},
				{
					id: 'minimize',
					icon: minimizeIcon
				},
				{
					id: 'maximize',
					icon: maximizeIcon
				},
				{
					id: 'image',
					icon: imageIcon
				},
				{
					id: 'video-file',
					icon: videoFileIcon
				},
				{
					id: 'webpage',
					icon: webpageIcon
				},
				{
					id: 'notebook',
					icon: notebookIcon
				},
				{
					id: 'filter',
					icon: filterIcon
				},
				{
					id: 'template',
					icon: templateIcon
				},
				{
					id: 'bullet-list',
					icon: bulletListIcon
				},
				{
					id: 'number-list',
					icon: numberedListIcon
				},
				{
					id: 'table',
					icon: tableIcon
				},
				{
					id: 'configure',
					icon: configureIcon
				},
				{
					id: 'connect',
					icon: connectIcon
				},
				{
					id: 'bullhorn',
					icon: bullhornIcon
				},
				{
					id: 'api',
					icon: apiIcon
				},
				{
					id: 'archive',
					icon: archiveIcon
				},
				{
					id: 'microphone',
					icon: microphoneIcon
				},
				{
					id: 'attachment',
					icon: attachmentIcon
				},
				{
					id: 'audio',
					icon: audioIcon
				},
				{
					id: 'bee',
					icon: beeIcon
				},
				{
					id: 'blog',
					icon: blogIcon
				},
				{
					id: 'bookmark',
					icon: bookmarkIcon
				},
				{
					id: 'calendar',
					icon: calendarIcon
				},
				{
					id: 'camera',
					icon: cameraIcon
				},
				{
					id: 'capability',
					icon: capabilityIcon
				},
				{
					id: 'catalog',
					icon: catalogIcon
				},
				{
					id: 'message',
					icon: messageIcon
				},
				{
					id: 'checkout',
					icon: checkoutIcon
				},
				{
					id: 'client',
					icon: clientIcon
				},
				{
					id: 'clock',
					icon: timeIcon
				},
				{
					id: 'cloud',
					icon: cloudIcon
				},
				{
					id: 'code',
					icon: codeIcon
				},
				{
					id: 'data-quality',
					icon: dataCheckIcon
				},
				{
					id: 'folder',
					icon: folderIcon
				},
				{
					id: 'forum',
					icon: forumIcon
				},
				{
					id: 'glasses',
					icon: glassesIcon
				},
				{
					id: 'group',
					icon: eventsIcon
				},
				{
					id: 'hat',
					icon: hatIcon
				},
				{
					id: 'headphones',
					icon: headphonesIcon
				},
				{
					id: 'hills',
					icon: hillsIcon
				},
				{
					id: 'home',
					icon: homeIcon
				},
				{
					id: 'idea',
					icon: ideaIcon
				},
				{
					id: 'inventory',
					icon: inventoryIcon
				},
				{
					id: 'like',
					icon: favoriteIcon
				},
				{
					id: 'location',
					icon: locationIcon
				},
				{
					id: 'pen',
					icon: markupPenIcon
				},
				{
					id: 'mobile',
					icon: mobileIcon
				},
				{
					id: 'music',
					icon: musicIcon
				},
				{
					id: 'notifications',
					icon: notificationsIcon
				},
				{
					id: 'paint',
					icon: paintIcon
				},
				{
					id: 'payment',
					icon: purchaseIcon
				},
				{
					id: 'password-key',
					icon: passwordIcon
				},
				{
					id: 'people',
					icon: peopleIcon
				},
				{
					id: 'person',
					icon: personIcon
				},
				{
					id: 'phone',
					icon: phoneIcon
				},
				{
					id: 'print',
					icon: printerIcon
				},
				{
					id: 'recording',
					icon: recordingIcon
				},
				{
					id: 'repository',
					icon: repositoryIcon
				},
				{
					id: 'role',
					icon: identificationIcon
				},
				{
					id: 'search',
					icon: searchIcon
				},
				{
					id: 'settings',
					icon: settingsIcon
				},
				{
					id: 'speaker',
					icon: speakerIcon
				},
				{
					id: 'star',
					icon: starIcon
				},
				{
					id: 'tag',
					icon: tagIcon
				},
				{
					id: 'thumbs-up',
					icon: thumbsUpIcon
				},
				{
					id: 'thumbs-down',
					icon: thumbsDownIcon
				},
				{
					id: 'tools',
					icons: toolsIcon
				},
				{
					id: 'traffic',
					icon: trafficIcon
				},
				{
					id: 'trash',
					icon: deleteIcon
				},
				{
					id: 'twitter',
					icon: twitterIcon
				},
				{
					id: 'unknown',
					icon: helpIcon
				},
				{
					id: 'user',
					icon: userIcon
				},
				{
					id: 'venn-diagram',
					icon: vennDiagramIcon
				},
				{
					id: 'video',
					icon: videoIcon
				},
				{
					id: 'view',
					icon: viewIcon
				},
				{
					id: 'warning',
					icon: warningIcon
				},
				{
					id: 'watch',
					icon: watchIcon
				},
				{
					id: 'watson',
					icon: watsonIcon
				},
				{
					id: 'wikis',
					icon: wikiIcon
				},
				{
					id: 'workspace',
					icon: workspaceIcon
				},
				{
					id: 'world',
					icon: globeIcon
				},
				{
					id: 'move',
					icon: moveIcon
				},
				{
					id: 'dashboard-templates',
					icon: dashboardTemplates
				},
				{
					id: 'arrowLeft',
					icon: arrowLeftIcon
				},
				{
					id: 'tabControl',
					icon: tabControl
				}, {
					id: 'distributeHorizontalCenter',
					icon: distributeHorizontalCenter
				}, {
					id: 'distributeVerticalCenter',
					icon: distributeVerticalCenter
				}, {
					id: 'zoomIn',
					icon: zoomIn
				}
			];
		}
	};
});
